"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITALY_COUNTRY_ID = exports.mainCustomerCountryIsoCodes = void 0;
exports.mainCustomerCountryIsoCodes = ["us", "ca", "au", "sg", "ph"];
exports.ITALY_COUNTRY_ID = "d277bb75-67b1-4e73-9a96-b9b5117b22d2";
//# sourceMappingURL=countries.js.map